import TomSelect from 'tom-select';

function init() {

	const forms = document.querySelectorAll('.smx-booking-form form');

	if(forms.length > 0){
        window.utils.forEach(forms, function (index, form) {

			const serviceSelect = form.querySelector('#smx-service');

			new TomSelect(serviceSelect, {
				placeholder: 'Seleziona un servizio',
				allowEmptyOption: true,
				searchField: ['text'],
				render: {
					no_results: function( data, escape ){
						return '<div class="no-results">Nessun risultato</div>';
					},
				},
			});
		})
	}
  
}

export default { init };